import React, { useState, useEffect } from 'react';
import { Layout, Menu, Button, Drawer } from 'antd';
import { MenuOutlined, UserOutlined } from '@ant-design/icons';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const { Header: AntHeader } = Layout;

const Header: React.FC = () => {
  const [mobileMenuVisible, setMobileMenuVisible] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  const menuItems = [
    { key: '/', label: 'Home' },
    { key: '/about', label: 'About' },
    { key: '/features', label: 'Features' },
    { key: '/pricing', label: 'Pricing' },
    { key: '/contact', label: 'Contact Us' },
  ];

  const showMobileMenu = () => {
    setMobileMenuVisible(true);
  };

  const onCloseMobileMenu = () => {
    setMobileMenuVisible(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      const heroSection = document.querySelector('.hero-section') as HTMLElement;
      if (heroSection) {
        const heroBottom = heroSection.offsetTop + heroSection.offsetHeight;
        const scrollPosition = window.scrollY + 70; // 70px is header height
        setIsScrolled(scrollPosition > heroBottom);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <AntHeader className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        <div className="logo">
          <Link to="/">
            <div className="logo-container">
              <img src="/images/logo.png" alt="byondcore" className="logo-image" />
            </div>
          </Link>
        </div>

        {/* Desktop Menu */}
        <div className="desktop-menu">
          <Menu
            mode="horizontal"
            selectedKeys={[location.pathname]}
            items={menuItems.map(item => ({
              key: item.key,
              label: <Link to={item.key}>{item.label}</Link>,
            }))}
          />
        </div>

        {/* Desktop Auth Buttons */}
        <div className="auth-buttons">
          <Button type="default" className="login-btn" icon={<UserOutlined />}>
            Login
          </Button>
          <Button type="primary" className="demo-btn">
            Get a Demo
          </Button>
        </div>

        {/* Mobile Menu Button */}
        <div className="mobile-menu-button">
          <Button
            type="text"
            icon={<MenuOutlined />}
            onClick={showMobileMenu}
          />
        </div>

        {/* Mobile Menu Drawer */}
        <Drawer
          title="Menu"
          placement="right"
          onClose={onCloseMobileMenu}
          open={mobileMenuVisible}
          width={250}
        >
          <Menu
            mode="vertical"
            selectedKeys={[location.pathname]}
            items={[
              ...menuItems.map(item => ({
                key: item.key,
                label: <Link to={item.key}>{item.label}</Link>,
              })),
              {
                key: 'login',
                label: 'Login',
                icon: <UserOutlined />,
              },
              {
                key: 'register',
                label: 'Register',
              },
            ]}
          />
        </Drawer>
      </div>
    </AntHeader>
  );
};

export default Header; 